export const colors = {
  primary: {
    DEFAULT: '#290717',
    100: '#F3F1F2',
    200: '#BDB3B8',
    300: '#674F5B',
  },
  secondary: {
    DEFAULT: '#9F133F',
    100: '#F9F2F4',
    200: '#D6B1BB',
    300: '#B95977',
    400: '#B95A77',
    500: '#DD93AA',
  },
  accent: {
    DEFAULT: '#C5C386',
    100: '#FBFBF8',
    200: '#F2F1E5',
    300: '#D6D4A8',
    400: '#B4B279',
  },
  gray: {
    DEFAULT: '#48403D',
    50: '#F4F4F4',
    100: '#DCDBDB',
    200: '#F2F1E5',
    300: '#D6D4A8',
    400: '#F4F4F4',
    500: '#A6A1A0',
  },
  danger: {
    DEFAULT: '#EA3A3D',
    100: '#f7b0b1',
    200: '#f5a0a2',
    300: '#ee6165',
  },
  success: {
    DEFAULT: '#19d598',
    100: '#a3eed6',
    200: '#47ddad',
    300: '#1AD598',
  },
  warning: {
    DEFAULT: '#F9B959',
    100: '#fde3bd',
    200: '#fbd59b',
    300: '#fac77a',
  },
};
